module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/redux-api-middleware/~/babel-runtime/core-js/object/set-prototype-of.js
// module id = 820
// module chunks = 0